import React, { useState } from "react";
import { Undo2, Loader2 } from "lucide-react";
import { voultRefund } from "@voult/api/base44Client";

// Admin-only refund control for an approved Voult payment.
export default function RefundControl({ txn, onDone }) {
  const left = Math.round((txn.amount - (txn.refunded_amount || 0)) * 100) / 100;
  const [open, setOpen] = useState(false);
  const [amount, setAmount] = useState(String(left));
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const go = async () => {
    setBusy(true); setErr("");
    try { onDone(await voultRefund(txn.id, { amount: parseFloat(amount) })); setOpen(false); }
    catch (e) { setErr(e.response?.data?.detail?.toString() || "Refund failed"); } finally { setBusy(false); }
  };

  if (!open) {
    return (
      <button data-testid="voult-refund-button" onClick={() => { setAmount(String(left)); setOpen(true); }}
        className="inline-flex items-center gap-1 text-[11px] font-medium text-amber-600 hover:text-amber-700">
        <Undo2 className="h-3 w-3" />Refund
      </button>
    );
  }
  return (
    <div className="flex flex-col items-end gap-1" data-testid="voult-refund-form">
      <div className="flex items-center gap-1">
        <input data-testid="voult-refund-amount" type="number" min="0.01" step="0.01" max={left} value={amount} onChange={(e) => setAmount(e.target.value)}
          className="w-20 rounded-lg border border-slate-200 px-2 py-1 text-xs font-mono" />
        <button data-testid="voult-refund-submit" onClick={go} disabled={busy} className="rounded-lg bg-amber-500 px-2 py-1 text-[11px] text-white hover:bg-amber-600 disabled:opacity-60">
          {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : "Confirm"}
        </button>
        <button onClick={() => setOpen(false)} className="text-[11px] text-slate-400 hover:text-slate-600">Cancel</button>
      </div>
      {err && <p data-testid="voult-refund-error" className="text-[11px] text-rose-500 max-w-[220px] text-right">{err}</p>}
    </div>
  );
}
